/**
 * @namespace farmnet.admin
 */

angular
  .module('farmnet.planning', [])
  .constant('PlanningConfig', {
    routeBasePath: '/planning'
  });
